__turbopack_context__.v({
  "artwork": "game-library-artwork-module__o9mIYW__artwork",
});
